import { render, staticRenderFns } from "./product-details-actions.vue?vue&type=template&id=67518124&"
import script from "./product-details-actions.vue?vue&type=script&lang=js&"
export * from "./product-details-actions.vue?vue&type=script&lang=js&"
import style0 from "./product-details-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports